import { useSeekaConverge } from "@seeka-labs/converge-react";
import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import {
  checkoutButton,
} from "../../src/pages/cart.module.css";
import { DarkButton } from "../components/buttons/dark-button";
import LineItemMiniCart from "../components/line-item-mini-cart";
import { Minicart } from "../components/minicart";
import { StoreContext } from "../context/store-context";
import Logo from "../icons/logo";
import {
  bluedDarkbutton
} from "../templates/products/single-product.module.css";
import { formatPrice } from "../utils/format-price";
import {
  billing,
  billingTotal,
  bottomCheck,
  checkoutGateway,
  guidanceMessage,
  header,
  Inline,
  label,
  labelEmpty,
  logos,
  miniCartEmpty,
  nav,
  reversebtn,
  scrollableContainer,
  shipping,
  shippingIcon,
  snotice,
  title
} from "./header.module.css";
import { Navigation } from "./navigation/navigation";

export default function Header() {
  const converge = useSeekaConverge()
  const { cart, loading, didJustAddToCart } = React.useContext(StoreContext)
  const emptyCart = !Boolean(cart?.lines?.length > 0)

  const handleCheckout = () => {
    window.open(converge ? converge.attribution.addCrossDomainTracking(cart.checkoutUrl) : cart.checkoutUrl)
  }

  const items = cart ? cart?.lines : []

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0);

  const [lineItemLoading, setLineItemLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay for LineItemMiniCart
    const timer = setTimeout(() => {
      setLineItemLoading(false);
    }, 2000);

    return () => clearTimeout(timer); // Clean up timer on component unmount
  }, []);

  return (
    <div>
      <Minicart
        show={didJustAddToCart}
      >
        {emptyCart ? (
          <div className={miniCartEmpty}>
            <h1 className={labelEmpty}>Your cart is empty</h1>
            <p className={guidanceMessage}>
              Looks like you haven’t found anything yet. We understand that
              sometimes it’s hard to choose — maybe this helps:
            </p>
            <br />
            <DarkButton className={bluedDarkbutton} to="/products/">
              <h3 className={label}>View All Art Works &rarr;</h3>
            </DarkButton>
          </div>
        ) : (
          <>
            <>
              <div className={title}>
                {quantity > 0 && <h3 className={label}>{quantity} Item/Items in your Cart</h3>}

                {!lineItemLoading && (
                  <div className={scrollableContainer}>
                    {cart.lines.map((item) => (
                      <LineItemMiniCart item={item} key={item.id} />
                    ))}
                  </div>
                )}
              </div>
              <br />
              {!lineItemLoading && (
                <div className={bottomCheck}>
                  {/* <p className={billing}>Subtotal:&nbsp; 
          {formatPrice(
                      cart.cost.subtotalAmount.currencyCode,
                      cart.cost.subtotalAmount.amount
                    )}
          </p>
           */}
                  <h4 className={billing}>
                    CART SUB TOTAL
                  </h4>
                  <h2 className={billingTotal}>

                    <>
                      ${formatPrice(
                        cart.cost.totalAmount.currencyCode,
                        cart.cost.totalAmount.amount
                      )}
                    </>
                  </h2>

                  {/* <em className={snotice}>Taxes:&nbsp;
          {formatPrice(
                      cart.totalTaxV2.currencyCode,
                      cart.totalTaxV2.amount
                    )}
          Calculated at checkout</em><br/> */}
                  <div className={checkoutGateway}>
                    <button disabled={loading} className={`${checkoutButton} ${Inline} ${reversebtn}`}>
                      <Link to="/cart" rel="alternate" hrefLang="en-SG">View Cart</Link>
                    </button>
                    <button
                      onClick={handleCheckout}
                      disabled={loading}
                      className={`${checkoutButton} ${Inline}`}
                    >
                      Checkout
                    </button>
                  </div>
                  <hr />
                  <div>
                    <br />
                    <span className={shipping}>
                      <em className={snotice}>Taxes: Calculated at checkout<br />For large art pieces, additional freight charges may apply.</em><br />
                      <svg className={shippingIcon} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"><path stroke-linejoin="round" stroke-miterlimit="1.5" d="M8 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4m10 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4" /><path d="M10.05 17H15V6.6a.6.6 0 0 0-.6-.6H1m4.65 11H3.6a.6.6 0 0 1-.6-.6v-4.9" /><path stroke-linejoin="round" d="M2 9h4" /><path d="M15 9h5.61a.6.6 0 0 1 .548.356l1.79 4.028a.6.6 0 0 1 .052.243V16.4a.6.6 0 0 1-.6.6h-1.9M15 17h1" /></g></svg>
                      Shipping costs will be calculated at the checkout.<br />
                    </span>
                    <br />
                  </div>
                  <hr />
                  <p><em className={snotice}>© 2024 Art Works. All rights reserved. <br />
                    We accept all major credit cards. We never store your credit card information, and your payment is secure.</em></p>
                </div>
              )}
            </>
          </>
        )}
      </Minicart>


      <header className={header}>
        <Link to="/" rel="alternate" hrefLang="en-SG">
          <div className={logos}>
            <Logo version="black" />
          </div>
        </Link>
        <Navigation className={nav} version="black" hiddenLinks={[]} />
        {/* <Link to="/search" className={searchButton}>
          <SearchIcon />
        </Link> */}
      </header>
    </div>
  )
}